var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuoteAf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#73889C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.592 15.556h-9.02a.591.591 0 0 0-.613.591c0 .339.274.613.613.613h9.02a.613.613 0 0 0 .592-.613.591.591 0 0 0-.592-.59zM8.572 12.885h9.02a.613.613 0 0 0 0-1.204h-9.02a.613.613 0 1 0 0 1.204z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.366 2.113a2.496 2.496 0 0 0-1.773-.745H7.915A3.832 3.832 0 0 0 4.105 5.2v15.458a3.832 3.832 0 0 0 3.81 3.831h10.312a3.853 3.853 0 0 0 3.832-3.831V8.835a2.518 2.518 0 0 0-.744-1.796l-4.949-4.926zm-.766.941 4.773 4.773h-3.437A1.357 1.357 0 0 1 15.6 6.492V3.054zm5.255 17.604a2.627 2.627 0 0 1-2.628 2.627H7.915a2.627 2.627 0 0 1-2.627-2.627V5.2a2.627 2.627 0 0 1 2.627-2.627h6.48v3.919a2.518 2.518 0 0 0 2.54 2.518h3.92v11.648z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.592 19.41h-9.02a.613.613 0 0 0-.613.613.591.591 0 0 0 .613.59h9.02a.591.591 0 0 0 .592-.59.613.613 0 0 0-.592-.613z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteAf);
export default __webpack_public_path__ + "static/media/quote-af.ede7530caecaae926b8fb973f2627006.svg";
export { ForwardRef as ReactComponent };